module.exports = __webpack_public_path__ + "fonts/nunito-sans-700-latin.c1e24b5.woff2";